import React, { useEffect } from "react";
import loadReviewsWidget from "services/load-reviews-widget";
import { useGlobalContext } from "context/global";
import { formatTitle } from "helpers/format-title";
import whenDOMNodeLoaded from "helpers/handle-dom-node.js";
import TotalReviews from "components/total-reviews";

const ReviewsSection = ({ data }) => {
	const { langCode } = useGlobalContext();

	useEffect(() => {
		loadReviewsWidget(data._key, langCode);

		whenDOMNodeLoaded(".R-ReviewsioLogo", (logoLink) => {
			logoLink.setAttribute("aria-label", "Read more reviews on REVIEWS.io");
		});
	}, [data._key, langCode]);

	return (
		<div className="mx-auto flex justify-center my-10 md:px-8 lg:my-20 gap-5 hd-screen-max-width">
			<div className="w-full text-center">
				<h2 className="mb-8">{formatTitle(data.title)}</h2>
				<TotalReviews direction="default" />
				<div id={data._key}></div>
			</div>
		</div>
	);
};

export default ReviewsSection;